export default __webpack_public_path__ + "static/media/logov2.6947d8a6.png";